import { render, staticRenderFns } from "./PageSubFooter.vue?vue&type=template&id=0f04ca01&"
import script from "./PageSubFooter.vue?vue&type=script&lang=js&"
export * from "./PageSubFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageSubFooter.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,SimpleLink: require('/opt/build/repo/storefront/components/atoms/Link/SimpleLink.vue').default,OutlineButton: require('/opt/build/repo/storefront/components/atoms/Button/OutlineButton.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default})
